import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Typography,
    TextField,
    IconButton,
    TablePagination
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styled, keyframes } from '@mui/system';
import ScrollToTopButton from '../Button/ScrollToTopButton';
import HomeIcon from '@mui/icons-material/Home';
import { motion } from 'framer-motion';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${slideInFromLeft} 0.5s ease-out`,
}));

const CustomerReport = () => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const [loading, setLoading] = useState(false);
    const [fetchedData, setFetchedData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const navigate = useNavigate();
    const [isSearchOpen, setIsSearchOpen] = useState(false);

    const toggleSearch = () => {
        setIsSearchOpen(!isSearchOpen);
    };
    {/**useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        }
    }, [token]);
    
    useEffect(() => {
        const fetchProfile = async () => {
            if (!token) return; // Exit if no token
    
            try {
                const response = await axios.get('https://admin.bizstor.lk/public/api/profile', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUser(response.data);
            } catch (error) {
                console.log('');
            }
        };
    
        fetchProfile();
    }, [token]);*/}

    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/"); // Redirect if no token
                return;
            }

            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/"); // Redirect on 401 error
                }
            }
        };

        fetchProfile();
    }, []);

    useEffect(() => {
        if (user.id) {
            fetchData();
        }
    }, [user.id]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-data');
            if (user.id) {
                {/**console.log('console.log("");:', user.id);*/ }

                // Filter orders based on user.id
                const Orders = response.data.filter(order =>
                    order.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );

                setFetchedData(Orders);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const filterData = (query, data) => {
        if (!query) {
            return data;
        } else {
            return data.filter((d) =>
                d.fullname?.toLowerCase().includes(query.toLowerCase()) // Null-safe check
            );
        }
    };


    const uniqueData = Array.from(new Set(fetchedData.map(order => order.fullname)))
        .map(fullname => fetchedData.find(order => order.fullname === fullname));

    const dataFiltered = filterData(searchQuery, uniqueData);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleBackClick = () => {
            navigate("/allreport");
        };


    return (
        <Box
        sx={{mt:10}}
        >
            <AnimatedTypography
                component="h1"
                sx={{
                    ml: { xs: 2, sm: 3 }, // Adjust margins for responsiveness
                    mt: { xs: 2, sm: 3 },
                    color: '',
                    letterSpacing: '0.01em',
                    fontSize: { xs: '20px', sm: '24px' }, // Responsive font size
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center',ml:1 }}>
                    {/**<Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' },
                            fontSize: { xs: '14px', sm: '16px' },
                            fontWeight: 'bold',
                            color: '',
                        }}
                    >
                        Customers
                    </Typography>
                    <Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' }, // Hidden on xs
                            ml: 1,
                            fontSize: '14px',
                            color: '',
                        }}
                    >
                        |
                    </Typography>*/}
                    <HomeIcon
                        sx={{
                            ml: 1,
                            fontSize: '18px',
                            color: '#6d7081',
                        }}
                    />
                    <Typography
                        component="span"
                        sx={{
                            ml: 0.5,
                            fontSize: '14px',
                            color: '#6d7081',
                        }}
                    >
                        - Report - Customers
                    </Typography>
                </Box>
            </AnimatedTypography>

            {/**<AnimatedTypography
                component="h1"
                sx={{
                    ml: 3,
                    mt: 3,
                    fontSize: '1rem',      // Adjust font size as needed
                    color: 'secondary.main', // Use theme color or specify a color like '#333'
                    letterSpacing: '0.01em' // Adjust letter spacing as needed
                }}
            >
                Dashboard / Report / Customer
            </AnimatedTypography>*/}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width:  {sm:'95%',xs:'90%'},
                    maxWidth: 'auto',
                    margin: 'auto',
                    //boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                    padding: '10px',
                    bgcolor: 'background.paper',
                    border: '1px solid #EDF2F7',
                    borderRadius: '16px',
                    marginTop: '30px',
                    position: 'relative',
                    '@media (max-width: 600px)': {
                        marginTop: '10px',
                    },
                }}
            >
                <Typography variant="h4" >

                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' }, // Responsive direction
                        justifyContent: 'space-between', // Space between left and right groups
                        alignItems: 'center', // Align items vertically
                        p: 2, // Padding inside the box
                        gap: 2, // Space between sections

                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection:'column',
                            alignItems: 'left', // Align items vertically
                            '@media (max-width: 600px)': {
                                margin: 'auto',
                            },
                            
                        }}
                    >
                        <Box sx={{color: '#1e293b',}}><h2>Customers</h2></Box>
                         <Box
                                                    component="div"
                                                    sx={{
                                                        mb: { sm: 2, xs: 'none' },
                                                        cursor: 'pointer',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        color: 'primary.main',
                                                        width: 'fit-content',
                                                        '&:hover': {
                                                            color: 'primary.main',
                                                        }
                                                    }}
                                                    onClick={handleBackClick}
                                                >
                                                    <ArrowBackIcon fontSize="small" />
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            ml: 0.5,
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        Back to Report
                                                    </Typography>
                                                </Box>
                    </Box>

                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: isSearchOpen ? 1 : 0, height: isSearchOpen ? 'auto' : 0 }}
                        transition={{ duration: 0.3 }}
                        style={{ overflow: 'hidden', }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on small screens
                                gap: 1, // Space between the TextFields
                                width: '80%', // Ensure it takes full width on smaller screens
                                alignItems: 'center', // Align items vertically
                                '@media (max-width: 600px)': {
                                    margin: 'auto',
                                },
                            }}
                        >
                            <TextField
                                variant="outlined"
                                margin="normal"
                                onChange={(e) => setSearchQuery(e.target.value)}
                                value={searchQuery}
                                size="small"
                                placeholder="Search…"
                                InputProps={{
                                    startAdornment: (
                                        <IconButton sx={{ padding: 0, mr: 1 }}>
                                            <SearchIcon />
                                        </IconButton>
                                    ),
                                }}
                                sx={{
                                    width: '250px',
                                    borderRadius: '8px',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                    },
                                }}
                            />
                        </Box>
                    </motion.div>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1, // Space between the icons
                        }}
                    >
                        <IconButton
                            onClick={toggleSearch}
                            sx={{
                                display: { sm: 'none', xs: 'flex' }
                            }}
                        >
                            <SearchIcon />
                        </IconButton>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: { sm: 'flex', xs: 'none' },
                        flexDirection: 'row',
                        width: '100%',
                        height: '50px',
                    }}
                >
                    <Box
                        sx={{
                            bgcolor: 'rgba(240, 240, 240, 0.17)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '20%',
                        }}
                    >
                        <TextField
                            variant="outlined"
                            margin="normal"
                            onChange={(e) => setSearchQuery(e.target.value)}
                            value={searchQuery}
                            size="small"
                            placeholder="Search…"
                            InputProps={{
                                startAdornment: (
                                    <IconButton sx={{ padding: 0, mr: 1 }}>
                                        <SearchIcon />
                                    </IconButton>
                                ),
                            }}
                            sx={{
                                mt: 1,
                                width: '245px',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                },
                            }}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '80%',
                        }}
                    ></Box>
                </Box>

                <TableContainer >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Name</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataFiltered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((order) => (
                                order.fullname ? (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={order.id}
                                        onClick={() => navigate(`/orders/${order.fullname}`)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <TableCell sx={{ color: '#636363', fontSize: '14px' }}>{order.fullname}</TableCell>
                                    </TableRow>
                                ) : null
                            ))}

                        </TableBody>
                    </Table>
                    <Box
                        display="flex"
                        justifyContent="center"
                        width="100%"
                        mt={2}
                    ><TablePagination
                            rowsPerPageOptions={[100, 200, 300]}
                            component="div"
                            count={dataFiltered.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage=""
                        /></Box>

                </TableContainer>
            </Box>
            {loading && (
                <Box sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'white',
                    zIndex: 9999
                }}>
                    <l-trio
                        size="50"
                        speed="1.3"
                        color="red"
                    ></l-trio>
                </Box>
            )}
            <ScrollToTopButton />
        </Box>
    );
};

export default CustomerReport;
